export const zeroPadForOne = (num: number) => String(num).padStart(2, "0");
